import { useState, useRef, useEffect } from "react";
import { useApp } from "../context/AppContext";
import ProjectMembers from "./ProjectMembers";
import { uid } from "../utils/helpers";

export default function ProjectInfo({ proj: p, updateProj }) {
  const { proj, activeId, getStore, setStore, dataRef, projects, setProjects, apiFetch,
    saveClusters, saveContent, saveStructure, saveSemClusters, saveLinks,
    flash, setView, view, dark, setDark, t, card, inp, btnP, btnG, btnSm, stitle, muted, th, td,
    userRole, currentUser, loadProjectData, openP, loadProjects, infoId, setInfoId, setActiveId } = useApp();
  const [form, setForm] = useState({
    name: p.name || "",
    domain: p.domain || "",
    startDate: p.startDate || "",
    payment: p.payment || "",
    budget: { dev: "", links: "", crowd: "", copy: "", pf: "", ...(p.budget || {}) },
    contractUrl: p.contractUrl || "",
    contractor: p.contractor || "",
    entityType: p.entityType || "",
    lang: p.lang || "",
    version: p.version || "",
    supplierDetails: p.supplierDetails || "",
    clientDetails: p.clientDetails || "",
    supplierName: p.supplierName || "",
    clientName: p.clientName || "",
    suppliersList: p.suppliersList?.length ? p.suppliersList : (p.supplierName ? [{ name: p.supplierName, details: p.supplierDetails || "" }] : []),
    clientsList: p.clientsList?.length ? p.clientsList : (p.clientName ? [{ name: p.clientName, details: p.clientDetails || "" }] : []),
    welcomeEmail: p.welcomeEmail || "",
    clientTelegramChatId: p.clientTelegramChatId || "",
    useProxy: p.useProxy || false,
  });
  const [invoices, setInvoices] = useState([]);
  useEffect(() => {
    const tk = localStorage.getItem("metago_token");
    if (tk && p.id) fetch(`/api/projects/${p.id}/invoices`, { headers: { Authorization: `Bearer ${tk}` } })
      .then(r => r.ok ? r.json() : []).then(d => { if (Array.isArray(d)) setInvoices(d); }).catch(() => {});
  }, [p.id]);
  const formRef = useRef(form);
  formRef.current = form;
  const save = () => updateProj(p.id, formRef.current);
  const set = (field, val) => setForm(prev => ({ ...prev, [field]: val }));
  const setBudget = (key, val) => setForm(prev => ({ ...prev, budget: { ...prev.budget, [key]: val } }));
  const btnStyle = (color) => ({ background: color, color: "#fff", border: "none", borderRadius: 8, padding: "8px 16px", fontSize: 12, fontWeight: 600, cursor: "pointer", display: "inline-flex", alignItems: "center", gap: 5 });

  // Auto-calc base
  const total = parseFloat(form.payment) || 0;
  const spent = ["dev", "links", "crowd", "copy", "pf"].reduce((s, k) => s + (parseFloat(form.budget[k]) || 0), 0);
  const base = total - spent;

  return (
    <div style={{ padding: "0 18px 16px", borderTop: `1px solid ${t.border}` }}>
      {/* Name & Domain */}
      <div style={{ display: "flex", gap: 8, flexWrap: "wrap", marginTop: 12 }}>
        <div style={{ flex: 1, minWidth: 180 }}>
          <label style={{ fontSize: 10, color: t.textMuted, fontWeight: 600, marginBottom: 6, display: "block" }}>🏢 Назва проєкту</label>
          <input value={form.name} onChange={e => set("name", e.target.value)} onBlur={save} placeholder="Назва проєкту" style={{ ...inp, fontSize: 12 }} />
        </div>
        <div style={{ flex: 1, minWidth: 220 }}>
          <label style={{ fontSize: 10, color: t.textMuted, fontWeight: 600, marginBottom: 6, display: "block" }}>🌍 Домен</label>
          <input value={form.domain} onChange={e => set("domain", e.target.value)} onBlur={save} placeholder="https://example.com/" style={{ ...inp, fontSize: 12 }} />
          <div style={{ fontSize: 10, color: t.textMuted, marginTop: 4 }}>Зміна домену впливає на збіг даних Ahrefs / GSC / позицій — міняйте свідомо.</div>
        </div>
      </div>

      {/* Language & Version */}
      <div style={{ display: "flex", gap: 8, flexWrap: "wrap", marginTop: 12 }}>
        <div style={{ flex: 1, minWidth: 140 }}>
          <label style={{ fontSize: 10, color: t.textMuted, fontWeight: 600, marginBottom: 6, display: "block" }}>🌐 Мова</label>
          <div style={{ display: "flex", gap: 6 }}>
            {[["UKR", "#6366f1"], ["RU", "#f59e0b"], ["ENG", "#22c55e"]].map(([lang, color]) => (
              <button key={lang} onClick={() => { setForm(prev => ({ ...prev, lang: prev.lang === lang ? "" : lang })); setTimeout(save, 50); }}
                style={{
                  padding: "6px 16px", borderRadius: 20, fontSize: 12, fontWeight: 700, cursor: "pointer",
                  border: `2px solid ${color}`,
                  background: form.lang === lang ? color : "transparent",
                  color: form.lang === lang ? "#fff" : color,
                  transition: "all .15s"
                }}>{lang}</button>
            ))}
          </div>
        </div>
        <div style={{ flex: 1, minWidth: 200 }}>
          <label style={{ fontSize: 10, color: t.textMuted, fontWeight: 600 }}>🏷 Версія що просувається</label>
          <input value={form.version} onChange={e => set("version", e.target.value)} onBlur={save} placeholder="v2.0, Lite, Pro..." style={{ ...inp, fontSize: 12 }} />
          <div style={{ marginTop: 8, display: "flex", alignItems: "center", gap: 8 }}>
            <label style={{ display: "flex", alignItems: "center", gap: 6, cursor: "pointer", fontSize: 11, color: t.textMuted, userSelect: "none" }}
              title="Всі запити Spalah до сайту (краулер, аудит, SDK) йдуть через Cloudflare — окремий IP. Вмикайте якщо хостинг блокує 173.242.59.154">
              <input type="checkbox" checked={!!form.useProxy} onChange={e => { set("useProxy", e.target.checked); setTimeout(save, 50); }} />
              🛡 Проксі-IP (Cloudflare)
            </label>
            {form.useProxy && <span style={{ fontSize: 10, color: "#22c55e", fontWeight: 600 }}>● активно</span>}
          </div>
        </div>
      </div>

      {/* Site language versions */}
      <VersionsBlock p={p} projects={projects} apiFetch={apiFetch} openP={openP} loadProjects={loadProjects} inp={inp} t={t} dark={dark} flash={flash} />

      <div style={{ display: "flex", gap: 8, flexWrap: "wrap", marginTop: 10 }}>
        <div style={{ flex: 1, minWidth: 140 }}>
          <label style={{ fontSize: 10, color: t.textMuted, fontWeight: 600 }}>📅 Дата старта</label>
          <input type="date" value={form.startDate} onChange={e => set("startDate", e.target.value)} onBlur={save} style={{ ...inp, fontSize: 12 }} />
        </div>
        <div style={{ flex: 1, minWidth: 140 }}>
          <label style={{ fontSize: 10, color: t.textMuted, fontWeight: 600 }}>💰 Сумма оплаты (общая)</label>
          <input value={form.payment} onChange={e => set("payment", e.target.value)} onBlur={save} placeholder="45000" style={{ ...inp, fontSize: 12 }} />
        </div>
      </div>

      {/* Budget breakdown */}
      <div style={{ marginTop: 10 }}>
        <div style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 6 }}>
          <label style={{ fontSize: 10, color: t.textMuted, fontWeight: 600 }}>📊 Разбивка бюджета</label>
          {total > 0 && (
            <div style={{ marginLeft: "auto", display: "flex", gap: 10, fontSize: 11 }}>
              <span style={{ color: "#6366f1", fontWeight: 700 }}>Базовая: {base >= 0 ? base.toLocaleString() : <span style={{ color: "#dc2626" }}>{base.toLocaleString()}</span>}</span>
              <span style={{ color: t.textMuted }}>Распред: {spent.toLocaleString()} / {total.toLocaleString()}</span>
            </div>
          )}
        </div>
        <div style={{ display: "flex", gap: 6, flexWrap: "wrap" }}>
          {[["dev", "🔧 Разработка"], ["links", "🔗 Рейт. ссылки"], ["crowd", "👥 Крауд"], ["copy", "✍️ Копирайтинг"], ["pf", "📈 ПФ"]].map(([key, label]) => (
            <div key={key} style={{ flex: 1, minWidth: 110 }}>
              <label style={{ fontSize: 9, color: t.textMuted }}>{label}</label>
              <input value={form.budget[key] || ""} onChange={e => setBudget(key, e.target.value)} onBlur={save} placeholder="0" style={{ ...inp, fontSize: 11, padding: "5px 8px" }} />
            </div>
          ))}
        </div>
        {/* Visual bar */}
        {total > 0 && (
          <div style={{ display: "flex", height: 6, borderRadius: 3, overflow: "hidden", marginTop: 8, background: dark ? "#333" : "#e5e7eb" }}>
            {base > 0 && <div style={{ width: (base / total * 100) + "%", background: "#6366f1" }} title={`Базовая: ${base}`} />}
            {(parseFloat(form.budget.dev) || 0) > 0 && <div style={{ width: ((parseFloat(form.budget.dev) || 0) / total * 100) + "%", background: "#f59e0b" }} title="Разработка" />}
            {(parseFloat(form.budget.links) || 0) > 0 && <div style={{ width: ((parseFloat(form.budget.links) || 0) / total * 100) + "%", background: "#22c55e" }} title="Ссылки" />}
            {(parseFloat(form.budget.crowd) || 0) > 0 && <div style={{ width: ((parseFloat(form.budget.crowd) || 0) / total * 100) + "%", background: "#06b6d4" }} title="Крауд" />}
            {(parseFloat(form.budget.copy) || 0) > 0 && <div style={{ width: ((parseFloat(form.budget.copy) || 0) / total * 100) + "%", background: "#ec4899" }} title="Копирайтинг" />}
          </div>
        )}
        {total > 0 && (
          <div style={{ display: "flex", gap: 10, marginTop: 4, fontSize: 9, color: t.textMuted, flexWrap: "wrap" }}>
            <span style={{ display: "flex", alignItems: "center", gap: 3 }}><span style={{ width: 8, height: 8, borderRadius: 2, background: "#6366f1", display: "inline-block" }} /> Базовая</span>
            <span style={{ display: "flex", alignItems: "center", gap: 3 }}><span style={{ width: 8, height: 8, borderRadius: 2, background: "#f59e0b", display: "inline-block" }} /> Разработка</span>
            <span style={{ display: "flex", alignItems: "center", gap: 3 }}><span style={{ width: 8, height: 8, borderRadius: 2, background: "#22c55e", display: "inline-block" }} /> Ссылки</span>
            <span style={{ display: "flex", alignItems: "center", gap: 3 }}><span style={{ width: 8, height: 8, borderRadius: 2, background: "#06b6d4", display: "inline-block" }} /> Крауд</span>
            <span style={{ display: "flex", alignItems: "center", gap: 3 }}><span style={{ width: 8, height: 8, borderRadius: 2, background: "#ec4899", display: "inline-block" }} /> Копирайтинг</span>
          </div>
        )}
      </div>

      <div style={{ display: "flex", gap: 8, flexWrap: "wrap", marginTop: 10 }}>
        <div style={{ flex: 1, minWidth: 200 }}>
          <label style={{ fontSize: 10, color: t.textMuted, fontWeight: 600 }}>📎 Ссылка на договор</label>
          <input value={form.contractUrl} onChange={e => set("contractUrl", e.target.value)} onBlur={save} placeholder="https://docs.google.com/..." style={{ ...inp, fontSize: 12 }} />
        </div>
      </div>

      {/* Entity type + contractor */}
      <div style={{ marginTop: 10 }}>
        <label style={{ fontSize: 10, color: t.textMuted, fontWeight: 600, marginBottom: 6, display: "block" }}>🏢 Контрагент</label>
        <div style={{ display: "flex", gap: 6, marginBottom: 8 }}>
          {[["ТОВ", "#6366f1"], ["ФОП 2", "#f59e0b"], ["ФОП 3", "#22c55e"]].map(([type, color]) => (
            <button key={type} onClick={() => { setForm(prev => ({ ...prev, entityType: prev.entityType === type ? "" : type })); setTimeout(save, 50); }}
              style={{
                padding: "6px 16px", borderRadius: 20, fontSize: 12, fontWeight: 700, cursor: "pointer",
                border: `2px solid ${color}`,
                background: form.entityType === type ? color : "transparent",
                color: form.entityType === type ? "#fff" : color,
                transition: "all .15s"
              }}>{type}</button>
          ))}
        </div>
        <textarea value={form.contractor} onChange={e => set("contractor", e.target.value)} onBlur={save} placeholder="Назва, контактна особа, телефон, email..." rows={2} style={{ ...inp, fontSize: 12, resize: "vertical" }} />
      </div>

      {/* Requisites for invoice — only iz@ */}
      {currentUser !== "iz@svitlo.agency" ? null : <>
      <div style={{ display: "flex", gap: 8, marginTop: 10 }}>
        {/* Suppliers */}
        <div style={{ flex: 1 }}>
          <label style={{ fontSize: 10, color: t.textMuted, fontWeight: 600, marginBottom: 4, display: "block" }}>📋 Постачальник</label>
          <div style={{ display: "flex", gap: 4, flexWrap: "wrap", marginBottom: 6 }}>
            {form.suppliersList.map((s, i) => (
              <button key={i} onClick={() => {
                setForm(prev => ({ ...prev, supplierName: s.name, supplierDetails: s.details }));
                setTimeout(save, 50);
              }} style={{
                padding: "3px 10px", borderRadius: 6, fontSize: 10, fontWeight: 600, cursor: "pointer",
                border: `1.5px solid ${form.supplierName === s.name ? "#6366f1" : (dark ? "#333" : "#ddd")}`,
                background: form.supplierName === s.name ? "rgba(99,102,241,0.12)" : "transparent",
                color: form.supplierName === s.name ? "#6366f1" : t.textMuted,
              }}>
                {s.name || `#${i + 1}`}
                <span onClick={e => { e.stopPropagation(); setForm(prev => {
                  const list = prev.suppliersList.filter((_, j) => j !== i);
                  const active = list.length ? list[0] : { name: "", details: "" };
                  return { ...prev, suppliersList: list, supplierName: active.name, supplierDetails: active.details };
                }); setTimeout(save, 50); }} style={{ marginLeft: 4, color: "#ef4444", fontSize: 9 }}>✕</span>
              </button>
            ))}
            <button onClick={() => {
              setForm(prev => ({ ...prev, suppliersList: [...prev.suppliersList, { name: "", details: "" }], supplierName: "", supplierDetails: "" }));
              setTimeout(save, 50);
            }} style={{ padding: "3px 8px", borderRadius: 6, fontSize: 10, cursor: "pointer", border: `1.5px dashed ${dark ? "#444" : "#ccc"}`, background: "none", color: t.textMuted }}>+</button>
          </div>
          <input value={form.supplierName} onChange={e => {
            const v = e.target.value;
            setForm(prev => {
              const idx = prev.suppliersList.findIndex(s => s.name === prev.supplierName);
              if (idx >= 0) { const list = [...prev.suppliersList]; list[idx] = { ...list[idx], name: v }; return { ...prev, supplierName: v, suppliersList: list }; }
              return { ...prev, supplierName: v };
            });
          }} onBlur={save} placeholder={'ТОВ "АЙЛАІН" / ФОП Замрика В.О.'} style={{ ...inp, fontSize: 12, marginBottom: 4 }} />
          <textarea value={form.supplierDetails} onChange={e => {
            const v = e.target.value;
            setForm(prev => {
              const idx = prev.suppliersList.findIndex(s => s.name === prev.supplierName);
              if (idx >= 0) { const list = [...prev.suppliersList]; list[idx] = { ...list[idx], details: v }; return { ...prev, supplierDetails: v, suppliersList: list }; }
              return { ...prev, supplierDetails: v };
            });
          }} onBlur={save}
            placeholder={"ЄДРПОУ: 43582929\nІПН: 435829226516\nр/р UA30...\nПАТ \"ПРИВАТБАНК\"\nАдреса: ...\nТел: +380..."}
            rows={4} style={{ ...inp, fontSize: 11, resize: "vertical", lineHeight: 1.5 }} />
        </div>
        {/* Clients */}
        <div style={{ flex: 1 }}>
          <label style={{ fontSize: 10, color: t.textMuted, fontWeight: 600, marginBottom: 4, display: "block" }}>📋 Отримувач (покупець)</label>
          <div style={{ display: "flex", gap: 4, flexWrap: "wrap", marginBottom: 6 }}>
            {form.clientsList.map((c, i) => (
              <button key={i} onClick={() => {
                setForm(prev => ({ ...prev, clientName: c.name, clientDetails: c.details }));
                setTimeout(save, 50);
              }} style={{
                padding: "3px 10px", borderRadius: 6, fontSize: 10, fontWeight: 600, cursor: "pointer",
                border: `1.5px solid ${form.clientName === c.name ? "#10b981" : (dark ? "#333" : "#ddd")}`,
                background: form.clientName === c.name ? "rgba(16,185,129,0.12)" : "transparent",
                color: form.clientName === c.name ? "#10b981" : t.textMuted,
              }}>
                {c.name || `#${i + 1}`}
                <span onClick={e => { e.stopPropagation(); setForm(prev => {
                  const list = prev.clientsList.filter((_, j) => j !== i);
                  const active = list.length ? list[0] : { name: "", details: "" };
                  return { ...prev, clientsList: list, clientName: active.name, clientDetails: active.details };
                }); setTimeout(save, 50); }} style={{ marginLeft: 4, color: "#ef4444", fontSize: 9 }}>✕</span>
              </button>
            ))}
            <button onClick={() => {
              setForm(prev => ({ ...prev, clientsList: [...prev.clientsList, { name: "", details: "" }], clientName: "", clientDetails: "" }));
              setTimeout(save, 50);
            }} style={{ padding: "3px 8px", borderRadius: 6, fontSize: 10, cursor: "pointer", border: `1.5px dashed ${dark ? "#444" : "#ccc"}`, background: "none", color: t.textMuted }}>+</button>
          </div>
          <input value={form.clientName} onChange={e => {
            const v = e.target.value;
            setForm(prev => {
              const idx = prev.clientsList.findIndex(c => c.name === prev.clientName);
              if (idx >= 0) { const list = [...prev.clientsList]; list[idx] = { ...list[idx], name: v }; return { ...prev, clientName: v, clientsList: list }; }
              return { ...prev, clientName: v };
            });
          }} onBlur={save} placeholder={'ТОВ "НАЗВА" / ФОП Іванов І.І.'} style={{ ...inp, fontSize: 12, marginBottom: 4 }} />
          <textarea value={form.clientDetails} onChange={e => {
            const v = e.target.value;
            setForm(prev => {
              const idx = prev.clientsList.findIndex(c => c.name === prev.clientName);
              if (idx >= 0) { const list = [...prev.clientsList]; list[idx] = { ...list[idx], details: v }; return { ...prev, clientDetails: v, clientsList: list }; }
              return { ...prev, clientDetails: v };
            });
          }} onBlur={save}
            placeholder={"ЄДРПОУ: ...\nІПН: ...\nр/р UA...\nБанк: ...\nАдреса: ..."}
            rows={4} style={{ ...inp, fontSize: 11, resize: "vertical", lineHeight: 1.5 }} />
        </div>
      </div>

      {/* Welcome email + Telegram chat ID — saved via surgical endpoint, accessible to SEO position users too */}
      <WelcomeEmailBlock p={p} form={form} setForm={setForm} save={save} apiFetch={apiFetch} flash={flash} inp={inp} t={t} dark={dark} />
      <TelegramChatBlock p={p} form={form} setForm={setForm} save={save} apiFetch={apiFetch} inp={inp} t={t} dark={dark} flash={flash} />
      <CloudflareBlock p={p} apiFetch={apiFetch} inp={inp} t={t} dark={dark} flash={flash} />
      <MembersBlock p={p} apiFetch={apiFetch} inp={inp} t={t} dark={dark} flash={flash} />

      {/* Invoice section */}
      {form.startDate && (() => {
        const now = new Date();
        const start = new Date(form.startDate);
        if (isNaN(start.getTime())) return null;

        // Calculate all periods from start
        const periods = [];
        let ps = new Date(start);
        while (true) {
          const pe = new Date(ps);
          pe.setMonth(pe.getMonth() + 1);
          periods.push({ start: new Date(ps), end: new Date(pe) });
          if (pe > now) break;
          ps = new Date(pe);
        }

        // Current period = last one where start <= now
        const currentIdx = periods.length - 1;
        const periodStart = periods[currentIdx].start;
        const periodEnd = periods[currentIdx].end;

        // Next period for invoice
        const nextStart = new Date(periodEnd);
        const nextEnd = new Date(nextStart);
        nextEnd.setMonth(nextEnd.getMonth() + 1);

        const daysLeft = Math.ceil((periodEnd - now) / (1000 * 60 * 60 * 24));

        const urgent = daysLeft <= 5;
        const fmtD = (d) => d.toLocaleDateString("uk-UA");
        const fmtISO = (d) => d.toISOString().slice(0, 10);

        return (
          <div style={{ marginTop: 12, padding: "12px 14px", borderRadius: 10, background: urgent ? (dark ? "rgba(239,68,68,0.06)" : "rgba(239,68,68,0.04)") : (dark ? "rgba(255,255,255,0.02)" : "rgba(0,0,0,0.015)"), border: `1px solid ${urgent ? "rgba(239,68,68,0.15)" : (dark ? "rgba(255,255,255,0.04)" : "rgba(0,0,0,0.04)")}` }}>
            <div style={{ fontSize: 11, fontWeight: 700, color: t.textMuted, marginBottom: 6 }}>💰 РАХУНКИ</div>
            <div style={{ fontSize: 12, color: t.textMuted, marginBottom: 6 }}>
              Поточний період: <strong style={{ color: t.text }}>{fmtD(periodStart)} — {fmtD(periodEnd)}</strong>
              <span style={{ marginLeft: 8, color: urgent ? "#ef4444" : t.textMuted, fontWeight: urgent ? 700 : 400 }}>({daysLeft} дн.)</span>
            </div>
            {/* Invoice periods */}
            {(() => {
              // Available periods to invoice
              const invoicePeriods = [
                { label: `Поточний: ${fmtD(periodStart)} — ${fmtD(periodEnd)}`, start: periodStart, end: periodEnd },
                { label: `Наступний: ${fmtD(nextStart)} — ${fmtD(nextEnd)}`, start: nextStart, end: nextEnd },
              ];

              const generateInvoice = async (ps, pe) => {
                try {
                  const tk = localStorage.getItem("metago_token");
                  const r = await fetch(`/api/projects/${p.id}/invoices/generate`, {
                    method: "POST",
                    headers: { "Content-Type": "application/json", Authorization: `Bearer ${tk}` },
                    body: JSON.stringify({ periodStart: fmtISO(ps), periodEnd: fmtISO(pe) }),
                  });
                  const d = await r.json();
                  if (d.error) { alert("Помилка: " + d.error); return; }
                  const win = window.open("", "_blank");
                  win.document.write(d.html);
                  win.document.close();
                  setTimeout(() => win.print(), 500);
                  const r2 = await fetch(`/api/projects/${p.id}/invoices/upload`, {
                    method: "POST",
                    headers: { "Content-Type": "application/json", Authorization: `Bearer ${tk}` },
                    body: JSON.stringify({ periodStart: fmtISO(ps), periodEnd: fmtISO(pe) }),
                  });
                  const d2 = await r2.json();
                  if (d2.invoice) setInvoices(prev => [d2.invoice, ...prev.filter(inv => inv.id !== d2.invoice.id)]);
                } catch (err) { alert("Помилка: " + err.message); }
              };

              const deleteInvoice = async (invId) => {
                try {
                  const tk = localStorage.getItem("metago_token");
                  await fetch(`/api/projects/${p.id}/invoices/${invId}`, { method: "DELETE", headers: { Authorization: `Bearer ${tk}` } });
                  setInvoices(prev => prev.filter(inv => inv.id !== invId));
                } catch {}
              };

              const redownload = (ps, pe) => generateInvoice(new Date(ps), new Date(pe));

              return (
                <div style={{ display: "flex", flexDirection: "column", gap: 6, marginTop: 8 }}>
                  {/* Generate buttons */}
                  {invoicePeriods.map((ip, i) => (
                    <div key={i} style={{ display: "flex", alignItems: "center", gap: 8, padding: "8px 12px", borderRadius: 8, background: dark ? "rgba(255,255,255,0.02)" : "rgba(0,0,0,0.02)", border: `1px solid ${dark ? "rgba(255,255,255,0.04)" : "rgba(0,0,0,0.04)"}` }}>
                      <span style={{ fontSize: 12, flex: 1 }}>{ip.label}</span>
                      {i === 0 ? (
                        <button onClick={() => generateInvoice(ip.start, ip.end)} style={btnStyle("#6366f1")}>
                          📄 Рахунок
                        </button>
                      ) : (
                        <span style={{ fontSize: 10, color: "#ef4444", fontWeight: 600, padding: "6px 12px", borderRadius: 8, background: "rgba(239,68,68,0.08)", border: "1px solid rgba(239,68,68,0.15)" }}>
                          🔒 Майбутній період
                        </span>
                      )}
                    </div>
                  ))}
                  {/* Existing invoices */}
                  {invoices.length > 0 && (
                    <div style={{ marginTop: 6 }}>
                      <div style={{ fontSize: 10, fontWeight: 700, color: t.textMuted, marginBottom: 4, textTransform: "uppercase", letterSpacing: 0.5 }}>Створені рахунки</div>
                      {invoices.map(inv => {
                        const isPaid = inv.status === "paid";
                        return (
                        <div key={inv.id} style={{ display: "flex", alignItems: "center", gap: 8, padding: "6px 10px", borderRadius: 6, marginBottom: 3, background: isPaid ? (dark ? "rgba(16,185,129,0.04)" : "rgba(16,185,129,0.03)") : (dark ? "rgba(245,158,11,0.04)" : "rgba(245,158,11,0.03)"), border: `1px solid ${isPaid ? (dark ? "rgba(16,185,129,0.1)" : "rgba(16,185,129,0.08)") : (dark ? "rgba(245,158,11,0.15)" : "rgba(245,158,11,0.1)")}` }}>
                          <span style={{ fontSize: 11, color: isPaid ? "#10b981" : "#f59e0b", fontWeight: 600 }}>{isPaid ? "✓" : "⏳"}</span>
                          <span style={{ fontSize: 11, flex: 1 }}>
                            {new Date(inv.period_start).toLocaleDateString("uk-UA")} — {new Date(inv.period_end).toLocaleDateString("uk-UA")}
                          </span>
                          <span style={{ fontSize: 9, fontWeight: 600, padding: "2px 6px", borderRadius: 4, color: isPaid ? "#10b981" : "#f59e0b", background: isPaid ? "rgba(16,185,129,0.1)" : "rgba(245,158,11,0.1)" }}>
                            {isPaid ? "Оплачено" : "Не оплачено"}
                          </span>
                          <span style={{ fontSize: 9, color: t.textMuted }}>{new Date(inv.sent_at || inv.created_at).toLocaleDateString("uk-UA")}</span>
                          <button onClick={() => redownload(inv.period_start, inv.period_end)} style={{ background: "none", border: "none", cursor: "pointer", fontSize: 12, color: "#6366f1", padding: "2px 4px" }} title="Скачати">📄</button>
                          <button onClick={() => deleteInvoice(inv.id)} style={{ background: "none", border: "none", cursor: "pointer", fontSize: 12, color: "#ef4444", padding: "2px 4px" }} title="Видалити">🗑</button>
                        </div>
                      );})}
                    </div>
                  )}
                </div>
              );
            })()}
          </div>
        );
      })()}

      </>}

      {/* Project members */}
      <ProjectMembers projectId={p.id} />

      {/* Action buttons */}
      <div style={{ display: "flex", gap: 8, marginTop: 12, flexWrap: "wrap", alignItems: "center" }}>
        {form.contractUrl && (
          <a href={form.contractUrl} target="_blank" rel="noopener" style={{ ...btnStyle("#6366f1"), textDecoration: "none" }}>📎 Договор</a>
        )}
        <button style={btnStyle("#22c55e")} onClick={() => {
          const email = (form.contractor.match(/[\w.-]+@[\w.-]+/)?.[0]) || "";
          const subj = encodeURIComponent(`Акт виконаних робіт — ${p.name}`);
          const body = encodeURIComponent(`Доброго дня!\n\nНадсилаємо акт виконаних робіт по проекту "${p.name}".\nПеріод: ${form.startDate || "—"}\nСума: ${form.payment || "—"}\n\nПрохання підписати та надіслати скан.\n\nЗ повагою`);
          window.open(`mailto:${email}?subject=${subj}&body=${body}`, "_blank");
        }}>📄 Відправити акти</button>
      </div>
    </div>
  );
}

function WelcomeEmailBlock({ p, form, setForm, save, apiFetch, flash, inp, t, dark }) {
  const email = form.welcomeEmail || "";
  const [sending, setSending] = useState(false);
  const saveContact = () => {
    apiFetch(`/api/projects/${p.id}/client-contact`, {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ welcomeEmail: form.welcomeEmail || "" }),
    }).catch(() => {});
  };
  const send = async () => {
    if (!email) { flash("Введіть email"); return; }
    setSending(true);
    try {
      const r = await apiFetch("/api/gmail/send-welcome", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email, clientName: form.clientName, projectName: p.name, domain: p.domain }),
      });
      if (r.ok) flash("✓ Лист надіслано");
      else { const d = await r.json().catch(() => ({})); flash("Помилка: " + (d.error || "не вдалося")); }
    } catch (e) { flash("Помилка: " + e.message); }
    finally { setSending(false); }
  };
  return (
    <div style={{ marginTop: 12, padding: 12, border: `1px solid ${t.border}`, borderRadius: 10, background: dark ? "rgba(99,102,241,0.05)" : "rgba(99,102,241,0.03)" }}>
      <label style={{ fontSize: 10, color: t.textMuted, fontWeight: 600, marginBottom: 6, display: "block" }}>📧 Супровідний лист клієнту</label>
      <div style={{ display: "flex", gap: 6 }}>
        <input value={email} onChange={e => setForm(prev => ({ ...prev, welcomeEmail: e.target.value }))} onBlur={saveContact} placeholder="client@example.com" style={{ ...inp, flex: 1, fontSize: 12 }} />
        <button onClick={send} disabled={sending} style={{ background: "#6366f1", color: "#fff", border: "none", borderRadius: 8, padding: "8px 16px", fontSize: 12, fontWeight: 600, cursor: sending ? "wait" : "pointer", whiteSpace: "nowrap" }}>
          {sending ? "..." : "Надіслати"}
        </button>
      </div>
    </div>
  );
}

function TelegramChatBlock({ p, form, setForm, save, apiFetch, inp, t, dark, flash }) {
  const v = form.clientTelegramChatId || "";
  const [pinging, setPinging] = useState(false);
  const [pingResult, setPingResult] = useState(null); // { ok, message }
  const saveContact = () => {
    apiFetch(`/api/projects/${p.id}/client-contact`, {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ clientTelegramChatId: form.clientTelegramChatId || "" }),
    }).catch(() => {});
  };
  const ping = async () => {
    // Save first (in case user edited without blur), then ping.
    setPinging(true);
    setPingResult(null);
    try {
      await apiFetch(`/api/projects/${p.id}/client-contact`, {
        method: "PUT", headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ clientTelegramChatId: v }),
      });
      const r = await apiFetch(`/api/projects/${p.id}/client-chat/ping`, { method: "POST" });
      const d = await r.json().catch(() => ({}));
      if (r.ok && d.ok) {
        setPingResult({ ok: true, message: `✅ Підключено! Бот написав у чат (${d.sentTo}).` });
        if (flash) flash("✅ Бот підключений до Spalah");
      } else {
        setPingResult({ ok: false, message: "❌ " + (d.error || "Не вдалось надіслати") });
      }
    } catch (e) {
      setPingResult({ ok: false, message: "❌ " + e.message });
    }
    setPinging(false);
  };
  return (
    <div style={{ marginTop: 12, padding: 12, border: `1px solid ${t.border}`, borderRadius: 10, background: dark ? "rgba(34,197,94,0.05)" : "rgba(34,197,94,0.03)" }}>
      <label style={{ fontSize: 10, color: t.textMuted, fontWeight: 600, marginBottom: 6, display: "block" }}>💬 Telegram Chat ID клієнта</label>
      <div style={{ display: "flex", gap: 8 }}>
        <input
          value={v}
          onChange={e => setForm(prev => ({ ...prev, clientTelegramChatId: e.target.value.trim() }))}
          onBlur={saveContact}
          placeholder="-1001234567890"
          style={{ ...inp, flex: 1, fontSize: 12, fontFamily: "monospace" }}
        />
        <button
          onClick={ping}
          disabled={pinging || !v}
          title={!v ? "Спочатку вставте Chat ID" : "Надіслати тестове повідомлення в чат"}
          style={{
            background: pinging ? "#9ca3af" : "#10b981", color: "#fff", border: "none",
            borderRadius: 8, padding: "8px 14px", fontSize: 12, fontWeight: 600,
            cursor: pinging || !v ? "wait" : "pointer", whiteSpace: "nowrap",
            opacity: !v ? 0.5 : 1,
          }}>
          {pinging ? "Перевіряю…" : "↻ Перевірити"}
        </button>
      </div>
      {pingResult && (
        <div style={{
          marginTop: 8, padding: "8px 10px", borderRadius: 6, fontSize: 11.5,
          background: pingResult.ok ? "rgba(16,185,129,0.10)" : "rgba(239,68,68,0.10)",
          color: pingResult.ok ? "#10b981" : "#ef4444",
        }}>{pingResult.message}</div>
      )}
      <div style={{ fontSize: 10, color: t.textMuted, marginTop: 6, lineHeight: 1.4 }}>
        Додайте бота <b>@svitlo_agent_bot</b> у чат з клієнтом → у боті напишіть <code>/id</code> → отриманий Chat ID вставте сюди → натисніть <b>Перевірити</b>.
        Бот напише в чат що підключено + почне слати оновлення по канбану/тікетам сюди.
      </div>
    </div>
  );
}

function CloudflareBlock({ p, apiFetch, inp, t, dark, flash }) {
  const [zone, setZone] = useState(p.cloudflareZoneId || "");
  const [token, setToken] = useState(p.cloudflareApiToken || "");
  const [saving, setSaving] = useState(false);
  const [verifying, setVerifying] = useState(false);
  const [verifyResult, setVerifyResult] = useState(null);
  const dirty = zone !== (p.cloudflareZoneId || "") || token !== (p.cloudflareApiToken || "");

  const save = async () => {
    setSaving(true); setVerifyResult(null);
    try {
      const r = await apiFetch(`/api/projects/${p.id}/cloudflare`, {
        method: "PUT", headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ cloudflareZoneId: zone, cloudflareApiToken: token }),
      });
      if (r.ok) flash("✓ Cloudflare збережено"); else flash("Помилка збереження");
    } catch (e) { flash("Помилка: " + e.message); }
    setSaving(false);
  };
  const verify = async () => {
    if (dirty) await save();
    setVerifying(true); setVerifyResult(null);
    try {
      const r = await apiFetch(`/api/projects/${p.id}/cloudflare/verify`, { method: "POST" });
      const d = await r.json();
      if (r.ok && d.ok) setVerifyResult({ ok: true, message: `✅ Token валідний (status: ${d.status})${d.zoneSet ? "" : " · ⚠ Zone ID не задано"}` });
      else setVerifyResult({ ok: false, message: "❌ " + (d.error || "Помилка") });
    } catch (e) { setVerifyResult({ ok: false, message: "❌ " + e.message }); }
    setVerifying(false);
  };
  return (
    <div style={{ marginTop: 12, padding: 12, border: `1px solid ${t.border}`, borderRadius: 10, background: dark ? "rgba(249,115,22,0.05)" : "rgba(249,115,22,0.03)" }}>
      <label style={{ fontSize: 10, color: t.textMuted, fontWeight: 600, marginBottom: 6, display: "block" }}>☁️ Cloudflare API (для auto-purge кешу при оновленні robots/мета)</label>
      <div style={{ display: "flex", flexDirection: "column", gap: 6 }}>
        <input value={zone} onChange={e => setZone(e.target.value.trim())} placeholder="Zone ID (32-char hex з CF dashboard → Overview)" style={{ ...inp, fontSize: 12, fontFamily: "monospace", width: "100%" }} />
        <input value={token} onChange={e => setToken(e.target.value.trim())} placeholder="API Token (My Profile → API Tokens → Create — потрібен Cache Purge permission)" type="password" style={{ ...inp, fontSize: 12, fontFamily: "monospace", width: "100%" }} />
        <div style={{ display: "flex", gap: 6 }}>
          <button onClick={save} disabled={!dirty || saving} style={{ background: "#6366f1", color: "#fff", border: "none", borderRadius: 6, padding: "6px 14px", fontSize: 12, fontWeight: 600, cursor: dirty ? "pointer" : "default", opacity: !dirty ? 0.5 : 1 }}>
            {saving ? "..." : "💾 Зберегти"}
          </button>
          <button onClick={verify} disabled={verifying || (!token && !p.cloudflareApiToken)} style={{ background: "#10b981", color: "#fff", border: "none", borderRadius: 6, padding: "6px 14px", fontSize: 12, fontWeight: 600, cursor: "pointer", opacity: verifying ? 0.7 : 1 }}>
            {verifying ? "Перевіряю..." : "↻ Перевірити"}
          </button>
        </div>
      </div>
      {verifyResult && (
        <div style={{ marginTop: 8, padding: "6px 10px", borderRadius: 6, fontSize: 11.5, background: verifyResult.ok ? "rgba(16,185,129,0.10)" : "rgba(239,68,68,0.10)", color: verifyResult.ok ? "#10b981" : "#ef4444" }}>
          {verifyResult.message}
        </div>
      )}
      <div style={{ fontSize: 10, color: t.textMuted, marginTop: 6, lineHeight: 1.4 }}>
        Коли задано — Spalah автоматично робить CF purge для <code>/robots.txt</code> після кожного оновлення через "Ручну оптимізацію". Інакше клієнт і Googlebot бачитимуть старий robots до природного expir.
      </div>
    </div>
  );
}

function MembersBlock({ p, apiFetch, inp, t, dark, flash }) {
  const [members, setMembers] = useState([]);
  const [available, setAvailable] = useState([]);
  const [loading, setLoading] = useState(false);
  const [adding, setAdding] = useState(false);
  const [newUserId, setNewUserId] = useState("");
  const [newRole, setNewRole] = useState("viewer");
  const canManage = p.myRole === "owner" || p.myRole === "admin";

  const load = async () => {
    setLoading(true);
    try {
      const r = await apiFetch(`/api/projects/${p.id}/members`);
      const d = await r.json();
      if (r.ok) setMembers(Array.isArray(d) ? d : []);
      if (canManage) {
        const ra = await apiFetch(`/api/projects/${p.id}/members/available`);
        const da = await ra.json();
        if (ra.ok) setAvailable(Array.isArray(da) ? da : []);
      }
    } catch {} finally { setLoading(false); }
  };
  useEffect(() => { load(); /* eslint-disable-next-line */ }, [p.id]);

  const addMember = async () => {
    if (!newUserId) return;
    setAdding(true);
    try {
      const r = await apiFetch(`/api/projects/${p.id}/members`, {
        method: "POST", headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ userId: parseInt(newUserId, 10), role: newRole }),
      });
      if (r.ok) { flash("✓ Учасника додано"); setNewUserId(""); setNewRole("viewer"); await load(); }
      else { const d = await r.json().catch(() => ({})); flash(d.error || "Помилка"); }
    } catch (e) { flash("Помилка: " + e.message); }
    setAdding(false);
  };

  const changeRole = async (userId, role) => {
    try {
      const r = await apiFetch(`/api/projects/${p.id}/members/${userId}`, {
        method: "PUT", headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ role }),
      });
      if (r.ok) { flash("✓ Роль оновлено"); await load(); }
      else { const d = await r.json().catch(() => ({})); flash(d.error || "Помилка"); }
    } catch (e) { flash("Помилка: " + e.message); }
  };

  const remove = async (userId, name) => {
    if (!window.confirm(`Видалити ${name} з проекту?`)) return;
    try {
      const r = await apiFetch(`/api/projects/${p.id}/members/${userId}`, { method: "DELETE" });
      if (r.ok) { flash("✓ Видалено"); await load(); }
      else { const d = await r.json().catch(() => ({})); flash(d.error || "Помилка"); }
    } catch (e) { flash("Помилка: " + e.message); }
  };

  const roleColor = (r) => r === "owner" ? "#a855f7" : r === "editor" ? "#3b82f6" : "#6b7280";
  const roleLabel = (r) => r === "owner" ? "Owner" : r === "editor" ? "Editor" : "Viewer";

  return (
    <div style={{ marginTop: 12, padding: 12, border: `1px solid ${t.border}`, borderRadius: 10, background: dark ? "rgba(99,102,241,0.04)" : "rgba(99,102,241,0.02)" }}>
      <label style={{ fontSize: 10, color: t.textMuted, fontWeight: 600, marginBottom: 6, display: "block" }}>👥 Учасники проекту ({members.length})</label>

      {loading ? (
        <div style={{ fontSize: 11, color: t.textMuted, padding: 8 }}>Завантаження…</div>
      ) : (
        <div style={{ display: "flex", flexDirection: "column", gap: 4 }}>
          {members.map(m => (
            <div key={m.user_id} style={{ display: "grid", gridTemplateColumns: "1fr 110px 30px", gap: 8, alignItems: "center", padding: "6px 10px", borderRadius: 6, background: dark ? "rgba(255,255,255,0.03)" : "rgba(0,0,0,0.02)" }}>
              <div style={{ minWidth: 0 }}>
                <div style={{ fontSize: 12, fontWeight: 600, color: t.text, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{m.full_name || m.username}</div>
                {m.full_name && <div style={{ fontSize: 10, color: t.textMuted, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{m.username}</div>}
              </div>
              {canManage ? (
                <select value={m.role} onChange={e => changeRole(m.user_id, e.target.value)} style={{ ...inp, fontSize: 11, padding: "4px 6px" }}>
                  <option value="viewer">Viewer</option>
                  <option value="editor">Editor</option>
                  <option value="owner">Owner</option>
                </select>
              ) : (
                <span style={{ fontSize: 10, fontWeight: 700, padding: "3px 8px", borderRadius: 4, background: roleColor(m.role) + "22", color: roleColor(m.role), textAlign: "center" }}>{roleLabel(m.role)}</span>
              )}
              {canManage ? (
                <button onClick={() => remove(m.user_id, m.full_name || m.username)} title="Видалити" style={{ background: "transparent", border: "none", color: "#ef4444", cursor: "pointer", fontSize: 14, padding: 2 }}>×</button>
              ) : <div></div>}
            </div>
          ))}
        </div>
      )}

      {canManage && available.length > 0 && (
        <div style={{ marginTop: 10, padding: 10, borderRadius: 8, background: dark ? "rgba(255,255,255,0.02)" : "rgba(0,0,0,0.015)", display: "grid", gridTemplateColumns: "1fr 110px auto", gap: 6 }}>
          <select value={newUserId} onChange={e => setNewUserId(e.target.value)} style={{ ...inp, fontSize: 12, padding: "6px 8px" }}>
            <option value="">— оберіть учасника —</option>
            {available.map(u => <option key={u.id} value={u.id}>{u.full_name || u.username}</option>)}
          </select>
          <select value={newRole} onChange={e => setNewRole(e.target.value)} style={{ ...inp, fontSize: 12, padding: "6px 8px" }}>
            <option value="viewer">Viewer</option>
            <option value="editor">Editor</option>
            <option value="owner">Owner</option>
          </select>
          <button onClick={addMember} disabled={!newUserId || adding} style={{ background: "#10b981", color: "#fff", border: "none", borderRadius: 6, padding: "6px 14px", fontSize: 12, fontWeight: 600, cursor: "pointer", opacity: !newUserId || adding ? 0.5 : 1 }}>
            {adding ? "..." : "+ Додати"}
          </button>
        </div>
      )}

      {!canManage && (
        <div style={{ fontSize: 10, color: t.textMuted, marginTop: 6, fontStyle: "italic" }}>
          Лише власник проекту або адмін агенції може керувати учасниками.
        </div>
      )}

      <div style={{ fontSize: 10, color: t.textMuted, marginTop: 8, lineHeight: 1.4 }}>
        <b>Viewer</b> — лише читання · <b>Editor</b> — може редагувати дані проекту · <b>Owner</b> — повний контроль + керування учасниками
      </div>
    </div>
  );
}


function VersionsBlock({ p, projects, apiFetch, openP, loadProjects, inp, t, dark, flash }) {
  const [open, setOpen] = useState(false);
  const [name, setName] = useState("");
  const [lang, setLang] = useState("");
  const [copyDomain, setCopyDomain] = useState(true);
  const [copyCompetitors, setCopyCompetitors] = useState(true);
  const [copyOnboarding, setCopyOnboarding] = useState(false);
  const [busy, setBusy] = useState(false);
  const groupKey = p.versionGroupId || p.id;
  const siblings = (projects || []).filter(x => (x.versionGroupId || x.id) === groupKey);
  const langColor = (l) => l === "UKR" ? "#6366f1" : l === "RU" ? "#f59e0b" : "#22c55e";
  const create = async () => {
    if (!name.trim()) { flash && flash("Вкажіть назву версії"); return; }
    setBusy(true);
    const newId = uid();
    try {
      await apiFetch(`/api/projects/${p.id}/versions`, {
        method: "POST",
        body: JSON.stringify({ id: newId, name: name.trim(), lang, copyDomain, copyCompetitors, copyOnboarding }),
      });
      if (loadProjects) await loadProjects();
      flash && flash("Версію створено");
      setOpen(false); setName(""); setLang("");
      openP(newId);
    } catch (e) {
      flash && flash("Помилка створення версії");
    }
    setBusy(false);
  };
  const chk = (val, setVal, label) => (
    <label style={{ display: "flex", alignItems: "center", gap: 6, fontSize: 12, color: t.text, cursor: "pointer" }}>
      <input type="checkbox" checked={val} onChange={e => setVal(e.target.checked)} /> {label}
    </label>
  );
  return (
    <div style={{ marginTop: 12, padding: "12px 14px", borderRadius: 10, background: dark ? "rgba(124,58,237,0.06)" : "rgba(124,58,237,0.04)", border: `1px solid ${dark ? "rgba(124,58,237,0.15)" : "rgba(124,58,237,0.12)"}` }}>
      <div style={{ display: "flex", alignItems: "center", gap: 8, flexWrap: "wrap" }}>
        <span style={{ fontSize: 11, fontWeight: 700, color: "#7c3aed", textTransform: "uppercase", letterSpacing: 0.5 }}>🌐 Версії сайту</span>
        {siblings.map(v => (
          <button key={v.id} onClick={() => openP(v.id)} title={v.domain || v.name}
            style={{ fontSize: 11, fontWeight: 700, padding: "3px 10px", borderRadius: 6, cursor: "pointer",
              border: `1.5px solid ${langColor(v.lang)}`,
              background: v.id === p.id ? langColor(v.lang) : "transparent",
              color: v.id === p.id ? "#fff" : langColor(v.lang) }}>
            {v.lang || "—"}{v.id === p.id ? " ●" : ""}
          </button>
        ))}
        <button onClick={() => setOpen(o => !o)} style={{ fontSize: 11, fontWeight: 600, padding: "4px 12px", borderRadius: 6, cursor: "pointer", border: "none", background: open ? "#7c3aed" : (dark ? "#1e1e2c" : "#ede9fe"), color: open ? "#fff" : "#7c3aed" }}>
          {open ? "× Скасувати" : "+ Додати версію"}
        </button>
      </div>
      {open && (
        <div style={{ marginTop: 10, display: "flex", flexDirection: "column", gap: 8 }}>
          <input value={name} onChange={e => setName(e.target.value)} placeholder="Назва версії (напр. avtek.ua/ua)" style={{ ...inp, fontSize: 12 }} />
          <div style={{ display: "flex", gap: 6, alignItems: "center", flexWrap: "wrap" }}>
            <span style={{ fontSize: 10, color: t.textMuted, fontWeight: 600 }}>Мова:</span>
            {[["UKR", "#6366f1"], ["RU", "#f59e0b"], ["ENG", "#22c55e"]].map(([l, color]) => (
              <button key={l} onClick={() => setLang(prev => prev === l ? "" : l)}
                style={{ padding: "5px 14px", borderRadius: 20, fontSize: 12, fontWeight: 700, cursor: "pointer",
                  border: `2px solid ${color}`, background: lang === l ? color : "transparent", color: lang === l ? "#fff" : color }}>{l}</button>
            ))}
          </div>
          <div style={{ display: "flex", gap: 16, flexWrap: "wrap" }}>
            {chk(copyDomain, setCopyDomain, "Копіювати домен")}
            {chk(copyCompetitors, setCopyCompetitors, "Копіювати конкурентів")}
            {chk(copyOnboarding, setCopyOnboarding, "Копіювати онбординг")}
          </div>
          <div>
            <button disabled={busy} onClick={create} style={{ background: "#22c55e", color: "#fff", border: "none", borderRadius: 8, padding: "8px 18px", fontSize: 12, fontWeight: 600, cursor: busy ? "default" : "pointer", opacity: busy ? 0.6 : 1 }}>
              {busy ? "Створення..." : "✓ Створити версію"}
            </button>
          </div>
        </div>
      )}
    </div>
  );
}
